import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Пазл размером 180x270мм состоит из 126 элементов. Представлен в горизонтальном и вертикальном форматах. Допускает печать разных файлов и изображений (jpg, tiff, psd, cdr, eps) с минимально допустимым разрешением 200 dpi.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
